import _defineProperty from "/workspace/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/workspace/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { ChainId } from '../../constants';

function isChainId(chainId) {
  return Object.values(ChainId).includes(chainId);
}

export function transactionReducer(state, action) {
  var _a;

  switch (action.type) {
    case 'ADD_TRANSACTION':
      {
        var chainId = action.payload.transaction.chainId;

        if (isChainId(chainId)) {
          return Object.assign(Object.assign({}, state), _defineProperty({}, chainId, [action.payload].concat(_toConsumableArray((_a = state[chainId]) !== null && _a !== void 0 ? _a : []))));
        } else {
          throw TypeError('Unsupported chain');
        }
      }

    case 'UPDATE_TRANSACTIONS':
      return Object.assign(Object.assign({}, state), _defineProperty({}, action.chainId, _toConsumableArray(action.transactions)));
  }
}